import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Observable } from 'rxjs';
import { JwtHelper } from 'angular2-jwt';
//import { JwtHelperService } from '@auth0/angular-jwt';
import { NotificationsService } from 'angular2-notifications';
import { Api } from './api';
import { Environment } from '../app.environment';
import { Authorization, Intake, Patient, ServerIntake,ProviderBio,SavePatientSchedule, CreateScheduleRequest } from '../models';
import { States } from '../services/states';


declare function redirectToPhs(isTest: boolean): any;


@Injectable()
export class Session {
  private _authenticationEvent = new Subject<boolean>();
  private _authenticated = false;
  private jwtHelper = new JwtHelper();

  authorization: Authorization = new Authorization;
  clientIntake: Intake = null;
  examIntake: Intake = null;
  intakeSchedule: CreateScheduleRequest = null;
  intakeScheduleDate: Date;

  intakeAllergens: any[];
  intakeLob: string;
  intakeBhType: string;
  intakeBhVisitModality: string;
  intakeRequestedProviderId: number;
  intakeMedications: any[];
  jwtToken: string;
  patient: Patient;
  patientId: number;
  serverIntake: ServerIntake;
  scheduleReuestId: Number;
  
  showMenu: boolean = true;
  stateList = []; 
  uploadFiles: any[];
  assesmentUrl: string = '';
  providerBio: ProviderBio;
  message: string = '';
  messageType: string ='';
  selectedLang: string = 'en';

  langChange: Subject<string> = new Subject<string>();

  constructor(private api: Api, 
              public environment: Environment,
              private router: Router,
              private service: NotificationsService,
              private states: States) {
    this.uploadFiles = new Array<any>();
    this.intakeMedications = new Array<any>();
    this.intakeAllergens = new Array<any>();
    this.intakeLob = '';
    this.jwtToken = '';
    this.scheduleReuestId = 0;
    this.intakeBhType = '';
    this.intakeBhVisitModality = '';
    this.intakeRequestedProviderId = 0;
    this.clientIntake = new Intake();
    
  }

  changeLang(_lang: string){
   
      this.selectedLang = _lang;
      this.langChange.next(this.selectedLang);

 
  }

  public get authenticationEvent() {
    return this._authenticationEvent.asObservable();
  }

  public get isAuthenticated() {
    return this._authenticated;
  }

  public setAuthenticated(authenticated: boolean) {
    this._authenticated = authenticated;
    this._authenticationEvent.next(this._authenticated);
  }

  public loginWithToken(token: string) {
    let requests = new Observable<boolean>(observer => {
      let auth = {'access_token': token,
                  'expires_in': 89999, 
                  'token_type': "bearer"};
      this.authorization = { ...auth };
      Api.bearerToken = auth.access_token;
      this.jwtToken = auth.access_token;
      let jwt = this.jwtHelper.decodeToken(token);
      this.patientId = jwt.nameid;
      this._authenticationEvent.next(true);
      let roles = jwt.role;
      let authorizedRole: boolean = false;
      if (roles.length > 0) {
        for (let i = 0; i < roles.length; i++) {
          if (roles[i] === 'User' || roles[i] === 'Site Member') {
            authorizedRole = true;
            break;
          }
        }
      }
        
      if (!authorizedRole) {
        //this.service.error('Login Failed', 'Invalid Login Credentials');
        observer.error('Unauthorized');
        redirectToPhs(false);
      } else {
        this.patientId = jwt.nameid;
        this._authenticated = true;
        let stateList = this.states.getStates();
        stateList.subscribe(response => {
          this.stateList = response;
        })
        this._authenticationEvent.next(true);
        observer.next(true)
      }
    });

    return requests;
  }

  public login(username: string, password: string) {
    redirectToPhs(false);
    // return an observable that performs two requests that the controller can subscribe to
    let requests = new Observable<boolean>(observer => {
      // get bearer token
      let tokenRequest = this.api.getBearerToken(username, password);

      tokenRequest.subscribe(auth => {
        // handle response
        Api.bearerToken = auth.access_token;
        this.jwtToken = auth.access_token;
        this.authorization = { ...auth };
        let jwt = this.jwtHelper.decodeToken(auth.access_token);
        let roles = jwt.role;
        if (!roles || roles.length === 0) {
          observer.error('Unauthorized');
        }

        let authorizedRole: boolean = false;
        if(Array.isArray(roles)){
          if (roles.length > 0) {
            for (let i = 0; i < roles.length; i++) {
              if (roles[i] === 'User' || roles[i] === 'Site Member') {
                authorizedRole = true;
                break;
              }
            }
          }
        }else{
          if(roles){
            if(roles === 'User' || roles === 'Site Member'){
              authorizedRole = true;
             
            }
          }
        }
   
        
        if (!authorizedRole) {
          console.log('beta');
          observer.error('Login Failed');
          this.service.error('Login Failed', 'Invalid Login Credentials');
        } else {
          this.patientId = jwt.nameid;
          let stateList = this.states.getStates();
          stateList.subscribe(response => {
            this.stateList = response;
          })
          this._authenticationEvent.next(true);
          observer.next(true)
        }
      }, err => {
        // notify parent observer
        observer.error(err);
        this.service.error('Login Failed', 'Invalid Login Credentials');
      });
    });

    return requests;
  }

  public createPatient(patient: Patient) {
    // return an observable that performs two requests that the controller can subscribe to
    let requests = new Observable<boolean>(observer => {
      // get bearer token
      let createPatientRequest = this.api.createPatient(patient);
      createPatientRequest.subscribe(patient => {
        let tokenRequest = this.api.getBearerToken(this.patient.email, this.patient.password);

        tokenRequest.subscribe(auth => {
          // handle response
          Api.bearerToken = auth.access_token;
          this.authorization = { ...auth };
          let jwt = this.jwtHelper.decodeToken(auth.access_token);
          this.patient.userId = jwt.nameid;
          this._authenticationEvent.next(true);

          this.patient = Object.assign(this.patient, patient);
          observer.next(true);
        }, err => {
          // notify parent observer
          observer.error(err);
        });
      }, err => {
        // notify parent observer
        observer.error(err);
      });
    });

    return requests;
  }

  public logout(redirect:boolean) {
    this.uploadFiles = [];
    this._authenticated = false;
    this.patientId = undefined;
    
    if(redirect === true){
      this.router.navigate(['/login']);
    }
  }
} 